/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

import { SkeletonText } from 'src/components/ts-components/SkeletonBlock'

const STAT_COUNT = 8

/** Cold-load placeholder for the Career Stats card: abbreviation-over-value stacks. */
const CareerStatsSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={cardStyles}>
      {Array.from({ length: STAT_COUNT }, (_, i) => (
        <div key={i} css={itemStyles}>
          <SkeletonText width={24} height={12} />
          <SkeletonText width={40} height={24} />
        </div>
      ))}
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

const cardStyles = css`
  display: flex;
  gap: 16px;
  padding: 16px 24px;
  overflow: hidden;
  border: 1px solid ${colors.SECONDARY_300};
  border-radius: 8px;
  background: ${colors.SECONDARY_400};
`

const itemStyles = css`
  flex: 1 0 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`

export default CareerStatsSkeleton
